import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const TravelPlanningCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [days, setDays] = useState('7');
  const [people, setPeople] = useState('2');
  const [dailyCost, setDailyCost] = useState('300,00');
  const [res, setRes] = useState<number | null>(null);

  const calculate = () => {
    const d = parseInt(days) || 0;
    const p = parseInt(people) || 0;
    const cost = parseFloat(parseBrazilianNumber(dailyCost)) || 0;
    const total = d * p * cost;
    setRes(total);
    onResultChange([{ label: 'Custo Total', value: `R$ ${total.toLocaleString('pt-BR')}` }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Dias" value={days} onChange={setDays} isNumeric required type="text" />
          <FormField label="Pessoas" value={people} onChange={setPeople} isNumeric required type="text" />
          <FormField label="Gasto Diário/Pessoa" value={dailyCost} onChange={setDailyCost} isNumeric required type="text" />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all">Calcular Viagem</button>
        </div>
        {res !== null && <ResultCard title="Total Estimado" value={`R$ ${res.toLocaleString('pt-BR')}`} color="indigo" />}
      </div>
    </div>
  );
};

export default TravelPlanningCalculator;
